export const isVisibleKioskItem = (item) => {
    if (!item) return false;
    return !!(item.isTop && item?.isActive && item?.kiosk && item?.defaultKiosk && item?.defaultAvailable);
};

export const isKioskVisibleCategory = (category) => {
    if (!category) return false;
    const visibleMenuItems = (category?.activeMenuItems || []).filter(isVisibleKioskItem);
    const hasVisibleChildCategories = (category?.activeMenuCategories || []).some(isKioskVisibleCategory);
    const r = !!(category.isTop && category?.isActive && category?.kiosk && category?.defaultAvailable && (visibleMenuItems.length > 0 || hasVisibleChildCategories));
    return r;
};

export const isRectVisibleInContainer = (rect, containerRect) => {
    if (!rect || !containerRect) return false;
    return rect.top < containerRect.bottom && rect.bottom > containerRect.top && rect.left < containerRect.right && rect.right > containerRect.left;
};

export const getVisibleKioskCategories = (menuCategories = [], containerRect, getCategoryRect) => {
    const eligibleCategories = filterForKiosk(menuCategories);
    if (!containerRect || typeof getCategoryRect !== 'function') return eligibleCategories;

    const measuredRects = eligibleCategories.map(category => ({ category, rect: getCategoryRect(category) })).filter(({ rect }) => rect);
    if (measuredRects.length === 0) return eligibleCategories;

    return measuredRects
        .filter(({ rect }) => isRectVisibleInContainer(rect, containerRect))
        .map(({ category }) => category);
};

export const filterForKiosk = (menuCategories = []) => {
    return [...(menuCategories || [])]
        .sort((a, b) => (b.entityType || '').localeCompare(a.entityType || ''))
        .filter(isKioskVisibleCategory)
        .map(category => ({
            ...category,
            activeMenuCategories: filterForKiosk(category?.activeMenuCategories || []),
            activeMenuItems: (category?.activeMenuItems || []).filter(isVisibleKioskItem)
        }));
};
